import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import AppUtils from '../../../utils/AppUtils'
import AppConstants from '../../../utils/AppConstants'
import ControlledProductForm from '../../../components/forms/ControlledProductForm'
import Popup from '../../../components/elements/Popup'

import Types from '../../../actions/Types'
import PostAction from '../../../actions/controlledProducts/PostAction'
import ListProductsAction from '../../../actions/products/ListAction'
import ListUsersAction from '../../../actions/users/ListAction'
import ClearErrorAction from '../../../actions/app/ClearErrorAction'

class AddControlledProductPopup extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      submit: null
    }

    // Bind events
    this.submit = this.submit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    this.props.fetchProducts()
    this.props.fetchUsers()
  }

  componentDidUpdate(prevProps, prevState) {
    // When successful, close popup
    if (
      prevProps.isSaving
      &&
      !this.props.isSaving
      &&
      !this.props.error
    ) {
      AppUtils.setStatus(AppConstants.STATUS.TYPE.SUCCESS, 'Matériel ajouté.')
      this.props.onClose(true)
    }
  }

  submit() {
    if (_.isFunction(this.state.submit)) {
      this.state.submit()
    }
  }

  onSubmit(data) {
    this.props.post(
      _.omit(data, 'product_id'),
      this.props.controlId,
      data.product_id
    )
  }

  render() {
    return (
      <Popup
        header='Ajouter un matériel à contrôler'
        body={
          <ControlledProductForm
            data={undefined}
            onSubmit={this.onSubmit}
            onClearError={this.props.clearError}
            isLoading={false}
            isSaving={this.props.isSaving}
            registerSubmit={(submit) => { this.setState({ submit })}}
            error={this.props.error}
            productsList={this.props.productsList}
            productsIsFetching={this.props.productsIsFetching}
            usersList={this.props.usersList}
            usersIsFetching={this.props.usersIsFetching}
          />
        }
        footer={[
          {
            type: Popup.BUTTONTYPE.CLOSE,
            title: 'Annuler',
            color: 'red',
            icon: 'close',
            basic: true,
            onClick: () => this.props.onClose(false)
          },
          {
            type: Popup.BUTTONTYPE.SUBMIT,
            title: 'Créer',
            color: 'green',
            icon: 'checkmark',
            onClick: this.submit
          }
        ]}
        isSaving={this.props.isSaving}
      />
    )
  }
}

AddControlledProductPopup.propTypes = {
  // Properties
  controlId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,

  // Redux State
  isSaving: PropTypes.bool.isRequired,
  error: PropTypes.object,
  productsList: PropTypes.array,
  productsIsFetching: PropTypes.bool.isRequired,
  usersList: PropTypes.array,
  usersIsFetching: PropTypes.bool.isRequired,

  // Redux Actions
  post: PropTypes.func.isRequired,
  fetchProducts: PropTypes.func.isRequired,
  fetchUsers: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    isSaving: state.entities.controls.product.post.isFetching,
    error: state.entities.controls.product.post.error,
    productsList: state.entities.products.list.data,
    productsIsFetching: state.entities.products.list.isFetching,
    usersList: state.entities.users.list.data,
    usersIsFetching: state.entities.users.list.isFetching
  }),
  (dispatch) => ({
    post: (data, id, product_id) => (dispatch(PostAction({ data, id, product_id }))),
    fetchProducts: () => (dispatch(ListProductsAction({}))),
    fetchUsers: () => (dispatch(ListUsersAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.CONTROLS.POST)))
  })
)(AddControlledProductPopup)



// WEBPACK FOOTER //
// ./src/containers/popups/controlledProducts/AddControlledProductPopup.js